import React, { useState, useEffect } from 'react';
import { Server, Cloud, Code } from 'lucide-react';

const A2AServerToggle = () => {
  // Detect if we're on Cloudflare/production
  const isProduction = typeof window !== 'undefined' && 
                       window.location.hostname !== 'localhost' && 
                       window.location.hostname !== '127.0.0.1' &&
                       !window.location.hostname.includes('localhost');
  
  const [useLocalhost, setUseLocalhost] = useState(() => {
    // If on production, force production mode (ignore localStorage)
    if (isProduction) {
      // Clear any localhost preference from localStorage
      localStorage.setItem('a2a_use_localhost', 'false');
      return false;
    }
    
    // For localhost, load from localStorage, default to false (production)
    const saved = localStorage.getItem('a2a_use_localhost');
    return saved === 'true';
  });

  useEffect(() => {
    // If on production, always use production URL (don't allow localhost)
    if (isProduction) {
      const serverUrl = 'https://a2achineseai-server.appsokay.net';
      if (window.updateA2AServerUrl) {
        window.updateA2AServerUrl(serverUrl);
        console.log(`[A2A Server Toggle] Production mode: Using Cloudflare server`);
      }
      // Force state to false
      if (useLocalhost) {
        setUseLocalhost(false);
      }
      return;
    }
    
    // For localhost, save preference and update URL
    localStorage.setItem('a2a_use_localhost', useLocalhost.toString());
    
    // Update server URL
    const serverUrl = useLocalhost 
      ? 'http://localhost:8787'
      : 'https://a2achineseai-server.appsokay.net';
    
    // Update the A2A client URL
    if (window.updateA2AServerUrl) {
      window.updateA2AServerUrl(serverUrl);
      console.log(`[A2A Server Toggle] Switched to: ${useLocalhost ? 'localhost:8787' : 'Cloudflare production server'}`);
    }
  }, [useLocalhost, isProduction]);

  return (
    <div className="fixed bottom-4 left-4 z-50">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-3 flex items-center gap-3">
        {/* Toggle Switch */}
        <div className="flex items-center gap-2">
          <Code className={`w-4 h-4 ${useLocalhost ? 'text-blue-600' : 'text-gray-400'}`} />
          <label className={`relative inline-flex items-center ${isProduction ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
            <input
              type="checkbox"
              checked={useLocalhost}
              onChange={(e) => {
                if (!isProduction) {
                  setUseLocalhost(e.target.checked);
                }
              }}
              disabled={isProduction}
              className="sr-only peer"
            />
            <div className={`w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 ${isProduction ? 'opacity-50' : ''}`}></div>
          </label>
          <Cloud className={`w-4 h-4 ${!useLocalhost ? 'text-green-600' : 'text-gray-400'}`} />
        </div>
        
        {/* Server Info */}
        <div className="flex flex-col">
          <span className="text-xs font-medium text-gray-700">
            {useLocalhost ? 'Localhost' : 'Cloudflare'}
          </span>
          <span className="text-xs text-gray-500">
            {useLocalhost ? 'localhost:8787' : 'Production'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default A2AServerToggle;

